<template><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
    <g transform="translate(0)" fill="none">
        <g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
            <path d="M358,231.5a6.3,6.3,0,0,0-6.25,6.346V239a.834.834,0,0,0,.833.833h10.833a.833.833,0,0,0,.833-.833v-1.156A6.3,6.3,0,0,0,358,231.5Z"
                  transform="translate(-351.005 -228.182)"/>
            <path d="M360.005,246.5v-.75a3,3,0,0,1,6,0v.75" transform="translate(-356.005 -234.849)"/>
            <path d="M364.77,237.458l-1.765,5.3" transform="translate(-356.561 -231.821)"/>
        </g>
    </g>
</svg>
</template>